import { useCallback, useRef } from 'react';
import { useRouter } from 'next/router';
import Image from '@base/Image';
import useCountdown from '@comp/Countdown/useCountdown';
import { getQuizDetails } from '@selectors/quizTaking';
import { useSelectorWithShallowEqual } from '@hooks/reduxHooks';
import { addTime } from '@utils/dates';
import Card from './Card';
import useQuizStatus from '../../Common/useQuizStatus';

const LightningIcon = 'quiz/lightning-black.svg';

const LiveNowCard = () => {
  const { query } = useRouter();
  const { quizUID } = query;

  const quizDetails = useSelectorWithShallowEqual(getQuizDetails(quizUID));

  const { handleIsLiveChange } = useQuizStatus();

  const liveRemainingRef = useRef(
    addTime(
      new Date(),
      quizDetails.quiz_over_in - quizDetails.time_remaining,
      's'
    )
  );

  const handleOnLiveExpire = useCallback(() => {
    handleIsLiveChange(false);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const { hours, minutes, seconds } = useCountdown(
    liveRemainingRef.current.getTime(),
    handleOnLiveExpire
  );

  const info = {
    text: 'Live now',
    subText: hours
      ? `${hours}h ${minutes}m ${seconds}s remaining`
      : `${minutes}m ${seconds}s remaining`
  };

  return (
    <Card
      icon={
        <Image width={25} height={25} src={LightningIcon} alt="live-icon" />
      }
      info={info}
    />
  );
};

export default LiveNowCard;
